import {css} from '@emotion/css';

import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  content: (isFirstContentElement?: boolean): string => css`
    label: richTextWithContents__content;
    position: relative;
    color: ${colours.font.BLACK};
    border-left: 1px solid ${colours.border.LIGHT_GRAY};

    ${isFirstContentElement &&
    `
      padding-top: ${spacing.XS};
    `}
  `,
  richText: css`
    label: richTextWithContents__richText;
    padding: ${spacing.XXS} ${spacing.XS};

    ${mq(Breakpoints.DESKTOP)} {
      padding: ${spacing.M} ${spacing.XS};
    }
  `,
  dialogueWithCtaContainer: css`
    label: richTextWithContents__dialogueWithCtaWithNoContainer;
    position: sticky;
    top: 0;
    z-index: 99;
  `,
};

export default styles;
